import { showSuccess, showError, showWarning } from "src/utils/notify";
import { boot } from "quasar/wrappers";

export default boot(({ app }) => {
  app.provide('showSuccess', showSuccess)
  app.provide('showError', showError)
  app.provide('showWarning', showWarning)
})
